const env = import.meta.env;

/** Build-time configuration (see web/.env.development and web/.env.production.example). */
export const config = {
  firebase: {
    apiKey: env.VITE_FIREBASE_API_KEY || 'demo-api-key',
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || 'demo-talkofthetown.firebaseapp.com',
    projectId: env.VITE_FIREBASE_PROJECT_ID || 'demo-talkofthetown',
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || 'demo-talkofthetown.appspot.com',
    appId: env.VITE_FIREBASE_APP_ID || '1:000000000000:web:demo',
  },
  useEmulators: env.VITE_USE_EMULATORS === 'true',
  emulatorHost: env.VITE_EMULATOR_HOST || '127.0.0.1',
  recaptchaSiteKey: env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY || '',
  contactEmail: env.VITE_CONTACT_EMAIL || '',
  /**
   * Paid posts: 'razorpay' (live checkout), 'fake' (the emulators: paying succeeds at once) or ''
   * (off: no Promote button).
   */
  payments: (env.VITE_PAYMENTS || (env.VITE_USE_EMULATORS === 'true' ? 'fake' : '')) as
    'razorpay' | 'fake' | '',
  /**
   * Google AdSense: the publisher id alone publishes ads.txt and the account meta tag (for
   * AdSense's site check); with an ad unit (slot) too, the board shows its one ad.
   */
  adsense: { client: env.VITE_ADSENSE_CLIENT || '', slot: env.VITE_ADSENSE_SLOT || '' },
  /** Currencies promotions can be paid in (comma-separated; USD needs international payments). */
  currencies: (env.VITE_PAYMENT_CURRENCIES || 'INR').split(',').map((c: string) => c.trim()),
} as const;
